export default __webpack_public_path__ + "static/media/logo-arrow.ffffd5a7.svg";